module.exports = __webpack_public_path__ + "static/media/NICE_Step5_end_card.cb54e3e5.jpg";